import { render, staticRenderFns } from "./customized.vue?vue&type=template&id=426a6001&scoped=true"
import script from "./customized.vue?vue&type=script&lang=js"
export * from "./customized.vue?vue&type=script&lang=js"
import style0 from "./customized.vue?vue&type=style&index=0&id=426a6001&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426a6001",
  null
  
)

export default component.exports